import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import SectionHeader from "@/components/SectionHeader";

const RULES = [
  { title: "1. No Cheating or Hacking",
    body: "X-ray, kill aura, auto-clickers, ESP, macros for combat and any client mod giving unfair advantage results in a permanent ban. Approved: OptiFine, minimap without cave/entity radar." },
  { title: "2. Respect Every Player",
    body: "No slurs, harassment, doxxing, or discrimination. Political and religious debates belong outside the server. Warnings escalate to mutes then bans." },
  { title: "3. Lifesteal Rules",
    body: "You can kill anyone in PvP zones. Teaming rules vary by season — check /season for current caps. Spawn-camping and abusing safezones is bannable." },
  { title: "4. Griefing & Stealing",
    body: "On Survival: raiding is allowed but total destruction of claimed towns is not. On Creative: griefing plots is an instant ban." },
  { title: "5. Chat & Advertising",
    body: "No spam, no external server ads, no NSFW content. Trade chat is for in-game trades only. English or Hindi in global chat." },
  { title: "6. Bug Abuse",
    body: "Duping, item glitches, and exploiting broken mechanics must be reported. Silent abuse = ban + item rollback." },
  { title: "7. Alt Accounts",
    body: "One alt allowed per player, must be linked in Discord. Using alts for vote spam, PvP advantage or ban evasion is not allowed." },
  { title: "8. Purchases & Refunds",
    body: "All store purchases are digital and final. Contact support within 48h for delivery issues. Chargebacks result in a permanent ban." },
  { title: "9. Staff Decisions",
    body: "Staff decisions are final. Appeals go through the Discord ticket system — arguing in-game just adds mute time." },
  { title: "10. Common Sense",
    body: "If it feels wrong, it probably is. This ruleset can't cover every scenario — staff will judge fairly." },
];

export default function Rules() {
  return (
    <div className="pt-32 pb-24 px-4 sm:px-6" data-testid="page-rules">
      <div className="max-w-3xl mx-auto">
        <SectionHeader eyebrow="Server Rules" title="Play Fair. Have Fun." subtitle="Read the full ruleset before hopping in. Ignorance isn't a defence against a ban." />
        <Accordion type="single" collapsible className="space-y-3">
          {RULES.map((r, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`rule-item-${i}`}
              className="glass rounded-xl border-white/10 px-4 [&>*]:border-none"
            >
              <AccordionTrigger className="text-left hover:no-underline font-semibold uppercase tracking-wide text-sm">
                {r.title}
              </AccordionTrigger>
              <AccordionContent className="text-white/70 leading-relaxed pb-4">
                {r.body}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
